import { Expose } from "class-transformer";

export default class InstagramStoreProfile {
  @Expose({ name: "store_id" }) storeId: number;
  @Expose() name: string;
  @Expose({ name: "instagram_account_id" }) instagramAccountId: string;
  @Expose({ name: "instagram_hashtag" }) instagramHashtag: string;
  static storeId: any;
}
